import { render, staticRenderFns } from "./RoundItemPanel.vue?vue&type=template&id=582fdf2e&scoped=true"
import script from "./RoundItemPanel.vue?vue&type=script&lang=ts"
export * from "./RoundItemPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./RoundItemPanel.vue?vue&type=style&index=0&id=582fdf2e&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./RoundItemPanel.vue?vue&type=style&index=1&id=582fdf2e&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "582fdf2e",
  null
  ,true
)

export default component.exports